var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"title mb-4"},[_vm._v("クリエイティブ設定")]),_c(_vm.component,{ref:"mode",tag:"div",attrs:{"form":_vm.form,"resources":[_vm.form.advertiser, _vm.form.insertionOrder]},on:{"changeBudgetSetting":function($event){return _vm.$emit('changeStep', 2)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }